import { render, staticRenderFns } from "./freightManagement.vue?vue&type=template&id=f5c11a0a&scoped=true&"
import script from "./freightManagement.vue?vue&type=script&lang=js&"
export * from "./freightManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c11a0a",
  null
  
)

export default component.exports